import { FC, ReactNode } from 'react';
import { Interpolation, Theme, css } from '@emotion/react';
import { Text } from '@frontend/design-system';

interface StatsFooterProps {
  text: ReactNode;
  styles?: Interpolation<Theme>;
}

export const StatsFooter: FC<StatsFooterProps> = ({ text, styles }) => {
  return (
    <Text size='small' color='subdued' css={[defaultStyles.footerText, styles]}>
      {text}
    </Text>
  );
};

const defaultStyles = {
  footerText: css`
    font-style: italic;
  `,
};
